import {SubAPI} from "./SubAPI";

// One orderable group of glass panes. A generated row is owned by the elevation that drew it —
// only its note and sort order are editable. A one-off is the user's in full.
export type GlazingItem = {
    id: number;
    project: number;
    product: number | null;

    drwRendering: number | null;
    opening: number | null;
    openingName: string | null;
    elevationName: string | null;

    // the marks of the panes this row covers, e.g. "P1, P3"
    marks: string;

    cutOutWidth: string;
    cutOutHeight: string;
    // the short end of a trapezoid lite; "" for a rectangle
    cutOutHeightShort: string;

    glassType: string | null;
    glassThermal: boolean | null;
    glassThickness: string | null;
    glassBead: string | null;
    glassUndersize: string | null;
    glassWidth: string | null;
    glassHeight: string | null;

    qtyPerElevation: number;
    qty: number;
    note: string;
    sortOrder: number;
    archived: boolean;

    generated: boolean;

    logictrl?: {
        edited: boolean;
        error: string | null;
        skipRules: boolean;
        conflictsWithMain: boolean;
    }
}

export type GlazingUpsert = {
    id: number;
    project: number;

    note: string;
    sortOrder: number;
    qty: number;
    archived: boolean;

    // one-off only; ignored on a generated row
    type?: string;
    thermal?: boolean;
    thickness?: string;
    bead?: string;
    undersize?: string;
    width?: string;
    height?: string;
}

export class Glazing extends SubAPI {
    list(props: {project: number}) {
        return this.fetcher.get<GlazingItem[]>("/api/glazing-items", props);
    }

    upsert(props: GlazingUpsert) {
        return this.fetcher.post<GlazingItem>("/api/glazing-item", props);
    }
}
